/**
 * Standardized date formats for consistent display across the application
 */
const STANDARD_DATE_FORMATS = {
  FULL_DATE: 'MMM D, YYYY', // Sep 11, 2024
  MONTH_DAY: 'MMM D', // Sep 11
  MONTH_YEAR: 'MMM, YYYY', // Sep, 2024
  QUARTER_YEAR: '[Q]Q YYYY', // Q3 2024
  YEAR_ONLY: 'YYYY', // 2024
  FULL_DATE_AND_TIME: 'MMM D, YYYY, hh:mm:ss', // Sep 11, 2024, 13:00:00
  DATE_TIME_24H: 'MMM D, YYYY, HH:mm', // Sep 11, 2024, 13:00
  // Slash-separated so each date stays legible inside a range label — with
  // hyphens, "2024-09-11 - 2024-09-30" reads as one run of dashes and the
  // separator between the two ends disappears into the dates.
  NUMERIC_DATE: 'YYYY/MM/DD', // 2024/09/11
} as const;

/**
 * Default timezone for operations
 */
const DEFAULT_TIMEZONE = 'UTC';

/**
 * Error messages for date operations
 */
const ERROR_MESSAGES = {
  INVALID_DATE: 'Invalid date provided',
  INVALID_FORMAT: 'Invalid date format',
  PARSE_ERROR: 'Failed to parse date string',
} as const;

export { DEFAULT_TIMEZONE, ERROR_MESSAGES, STANDARD_DATE_FORMATS };
